'use strict';

var ServiceDemandGridFilterFactory = function ServiceDemandGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'ServiceDemandDowFilterFactory', 'ServiceDemandClassFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ServiceDemandGridFilter() {
    DemandFilter.call(this, ['service', 'booking-matrix'], ['service-demand-analysis', 'service-demand-analysis-booking-matrix']);
    this.registerFilters(injectedFilters);
  }
  ServiceDemandGridFilter.constructor = ServiceDemandGridFilter;
  ServiceDemandGridFilter.prototype = Object.create(DemandFilter.prototype);
  ServiceDemandGridFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ServiceDemandGridFilter;
};
ServiceDemandGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ServiceDemandGridFilterFactory;